import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "./Admin";
import PageTransition from "./PageTransition";

const Dashboard = () => {
    const { user } = useContext(AuthContext);

    return (
        <PageTransition>
            <div className="dashboard">
                <h1>Welcome, {user?.username || "Admin"}</h1>
                <p>
                    This is the Ellington Map CMS dashboard. Use the navigation menu
                    or the cards below to manage content.
                </p>

                <div className="dashboard-info">
                    <p>
                        <strong>Note:</strong> All changes made through this CMS are
                        immediately reflected on the website. Make sure to preview
                        your changes before saving.
                    </p>
                </div>

                {/* <div className="dashboard-cards">
                    <div className="dashboard-card">
                        <h2>Content Management</h2>
                        <ul>
                            <li>
                                <Link to="/admin/properties">Properties</Link> - Manage property details and listings
                            </li>
                        </ul>
                    </div>
                </div> */}
            </div>
        </PageTransition>
    );
};

export default Dashboard;
